import {CommonStatus} from "@/enums/status";

export class ContactParams {
    page? = 1;
    limit? = 10;
    phoneNumber?: string;
    provinceId?: string;
    districtId?: string;
    postOfficeRowGuid?: string;
    partnerRowGuid?: string;
    status?: CommonStatus = CommonStatus.Active;
}
